// extracted by mini-css-extract-plugin
export default {"root":"theme_root__9Scj3"};